import { render } from "./PageHasilWawancaraPsikolog.vue?vue&type=template&id=2b4a853a"
import script from "./PageHasilWawancaraPsikolog.vue?vue&type=script&lang=js"
export * from "./PageHasilWawancaraPsikolog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__